export class UserTransaction {
  activatedAt;
  comment;
  createdAt;
  expiredAt;
  id;
  orderId;
  status;
  statusInfo;
  statusLabel;
  type;
  typeLabel;
  updatedAt;
  userId;
  value;
  constructor(data) {
    this.orderId = data.order_id;
    this.comment = data.comment;
    this.userId = data.user_id;
    this.activatedAt = data.activated_at;
    this.id = data.id;
    this.status = data.status;
    this.expiredAt = data.expired_at;
    this.typeLabel = data.type_label;
    this.value = data.value;
    this.updatedAt = data.updated_at;
    this.createdAt = data.created_at;
    this.type = data.type;
    this.statusLabel = data.status_label;
    this.statusInfo = data.status_info;
  }
  toJSON() {
    return { ...this };
  }
}
